<template>
    <div>
        <div v-if="loading || isPrinting">
            <spin-while-loading :dspin="loading || isPrinting"
                                :title="isPrinting ? $t('printingInProcess') : null">
            </spin-while-loading>
        </div>

        <div v-else>
            <form class="flow-form-cum-panel w3-col flow-margin-bottom zero-left">
                <p class="w-45pc flow-form-inline-input zero-top w3-left">
                    <label class="w3-left flow-blue-color w3-margin-bottom w3-margin-top w-100pc">
                        {{ $t("tag") }}
                    </label>
                    <input disabled class="w3-input" type="text" placeholder="Tag" v-model="selectedPatient.ticket">
                </p>

                <span class="flow-form-inline-input zero-top w3-left">
                    <label class="w3-left flow-blue-color w3-margin-bottom w3-margin-top w-100pc">
                        {{ $t("printer") }}
                    </label>
                    <span class="w-100pc flowselect"
                          v-bind:class="selectPrinterError ? 'error' : ''">
                        <select class="cursor-pointer"
                                v-model="selectedPrinter">
                            <option :value="null" disabled>
                                {{ $t("selectPrinter") }}
                            </option>
                            <option v-for="p in printers" v-bind:value="p.id">
                                {{ p.id }} ({{ p.ip }}:{{ p.port }})
                            </option>
                        </select>
                        <i class="fa fa-chevron-down flow-green-active-color"></i>
                    </span>
                    <p class="w3-text-red">
                        {{ selectPrinterError }}
                    </p>
                </span>
            </form>

            <button class="w3-margin-left flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-large"
                    @click.prevent="printPatient">
                <i class="fa w3-text-blue fa-print">
                        <span>
                            <b class="flow-margin-left">
                                {{ $t('print') }}
                            </b>
                        </span>
                </i>
            </button>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import PatientNameHeader from "../common/PatientNameHeader";
    import Loader from "../Loader";
    import SpinWhileLoading from "../common/Loading";
    import PatientStatus from "../common/PatientStatus";

    const frc = Vue.prototype.$frc;

    export default {
        name: "PrintPatient",
        components: {PatientStatus, SpinWhileLoading, Loader, PatientNameHeader},
        props: ['selectedPatient'],
        data: function () {
            return {
                loading: true,
                printers: [],
                selectedPrinter: null,
                jobStatusTimeoutId: null,
                jobStatus: null,
                awaitStatus: "AWAITING_RESPONSE",
                selectPrinterError: null
            }
        },
        watch: {
            selectedPatient() {
                this.reset();
                this.setCurrentPrinterAsLastUsed();
            },
            jobStatus(newVal) {
                if (null == newVal || this.isAwaiting(newVal)) {
                    return;
                }

                if (newVal.status === "SUCCESS") {
                    Vue.notifySuccess({
                        title: this.$t('printSuccess')
                    });
                } else if (newVal.status === "FAILED") {
                    Vue.notifyError({
                        title: this.$t('printFailed'),
                        message: newVal.message
                    });
                }
            }
        },
        computed: {
            isPrinting() {
                return this.isAwaiting(this.jobStatus);
            }
        },
        mounted() {
            this.getPrinters();
            this.setCurrentPrinterAsLastUsed();
        },
        beforeDestroy() {
            this.endTimeout();
        },
        methods: {
            isAwaiting(statusVal) {
                return null != statusVal && statusVal.status === this.awaitStatus;
            },
            reset() {
                this.selectedPrinter = null;
                this.endTimeout();
                this.jobStatusTimeoutId = null;
                this.jobStatus = null;
                this.selectPrinterError = null;
            },
            endTimeout() {
                if (null != this.jobStatusTimeoutId) clearTimeout(this.jobStatusTimeoutId);
            },
            getPrinters() {
                const app = this;
                frc.getPrinters().then(function (res) {
                    if (!res || !res.data) throw new Error('Invalid data');
                    app.printers = res.data;
                    app.loading = false;
                });
            },
            printPatient() {
                this.selectPrinterError = null;
                
                if (!this.selectedPrinter) {
                    this.selectPrinterError = this.$t('selectPrinterError');
                    return;
                }

                this.saveLatestUsedPrinterId(this.selectedPrinter);

                //TODO re-introduce the status checks
                //this.jobStatus = {status: this.awaitStatus};
                const app = this;
                console.log(this.selectedPatient)
                frc.printQRCodeForFlowPatientId(this.selectedPatient.id,this.selectedPrinter)
                //frc.printPatient(this.selectedPrinter, this.selectedPatient.id)
                    .then(function (res) {
                        Vue.notifySuccess({title:app.$t("printingOn:")+app.selectedPrinter})
                        //app.trackJobStatus(res.data.id);
                    });
            },
            trackJobStatus(jobId) {
                const app = this;
                this.jobStatusTimeoutId = setTimeout(function () {
                    app.getJobStatus(jobId)
                }, 2000);
            },
            getJobStatus(jobId) {
                const app = this;
                frc.getPrintJobStatus(jobId).then((function (res) {
                    app.jobStatus = res.data;
                    if (app.isAwaiting(app.jobStatus)) {
                        app.trackJobStatus(jobId);
                    }
                }));
            },
            saveLatestUsedPrinterId(printerId) {
                localStorage.setItem('lastUsedPrinter', printerId);
            },
            getLastUsedPrinter() {
                return localStorage.getItem('lastUsedPrinter');
            },
            setCurrentPrinterAsLastUsed() {
                this.selectedPrinter = this.getLastUsedPrinter();
            }
        }
    }
</script>